import { FC } from 'react'
import { Option, Select } from '@cargomart/ui'
import cn from 'classnames'
import { formattedOrderPaymentStatus } from 'modules/order/helpers'
import { TOption } from 'modules/order/pages/OrderList/types'
import { paymentStatusOptions } from 'modules/order/types'

import s from './OrderFilterSelect.module.less'

export interface OrderFilterPaymentStatusSelectProps {
  isLaptop: boolean
  onChange: (value: TOption[]) => void
  paymentStatus: TOption[] | null | undefined
  prefix: React.ReactNode
}

export const OrderFilterPaymentStatusSelect: FC<OrderFilterPaymentStatusSelectProps> = ({
  paymentStatus,
  isLaptop,
  prefix,
  onChange
}) => (
  <Select
    isMultiple
    className={cn(s.filterSelect, { [s.filterSelectActive]: paymentStatus?.length })}
    fullscreenName="Оплата"
    isFullscreen={isLaptop}
    maxOptionListWidth={234}
    onChange={onChange}
    prefix={prefix}
    value={paymentStatus}
  >
    {paymentStatusOptions.map((option) => (
      <Option
        key={option.id}
        isCheckIcon
        className={cn(s.filterOption, s.filterPaymentStatusOption)}
        title={formattedOrderPaymentStatus(option.name)}
        value={option}
      />
    ))}
  </Select>
)
